import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import { CreditNoteOperationResult } from "../entities/CreditNoteEntity";

/**
 * Reject Credit Note Use Case
 * Rejects a credit note
 */
export class RejectCreditNoteUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(creditNoteId: number): Promise<CreditNoteOperationResult> {
    return await this.repository.rejectCreditNote(creditNoteId);
  }
}
